
import EmptyWalletTime from "../../../assets/duotone/EmptyWalletTime.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EmptyWalletTimeIcon({ className, dataTestid = "EmptyWalletTimeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <EmptyWalletTime data-testid={dataTestid} className={classes} {...rest} />
  );
}
